"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PBKDF2 = void 0;
const algoTypes_1 = require("./algoTypes");
class PBKDF2 {
    type = algoTypes_1.AlgoTypes.pbkdf2;
    iterations;
    keylet;
    iv;
    encrypt;
}
exports.PBKDF2 = PBKDF2;
//# sourceMappingURL=pbkdf2.js.map